import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import configureStore from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { useState } from 'react';
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { setUnauthorizedHandler } from './server';
import { userLoaded } from './redux/actions';
import { antdTheme, ColorThemeContext, readColorTheme, writeColorTheme } from './theme';

dayjs.locale('ru');

const { store, persistor } = configureStore();
setUnauthorizedHandler(() => store.dispatch(userLoaded(null)));

document.documentElement.dataset.theme = readColorTheme();

const Root = () => {
    const [colorTheme, setColorThemeState] = useState(readColorTheme);

    const setColorTheme = (next) => {
        const value = next === 'dark' ? 'dark' : 'light';
        writeColorTheme(value);
        document.documentElement.dataset.theme = value;
        setColorThemeState(value);
    };

    return (
        <ColorThemeContext.Provider value={{ colorTheme, setColorTheme }}>
            <ConfigProvider locale={ru_RU} theme={antdTheme(colorTheme)}>
                <App />
            </ConfigProvider>
        </ColorThemeContext.Provider>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Root />
      </PersistGate>
    </Provider>
);
